<template>
    <v-card flat>
        <v-card-title
            class="deep-purple darken-4 white--text"
        >
            Nouveau rôle
            <v-spacer />
            <v-icon
                color="white"
                class="clickable"
                @click="clearDialog"
            >mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
            <v-text-field
                v-model="role.name"
                @input="stdRole"
                :messages="[`Entrez le nom du nouveau rôle`]"
            ></v-text-field>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'RolesDialog',
    props: [
        'roles',
        'item',
    ],
    data: () => ({
        progress: {
            index: 0,
            items: null,
        },
    }),
    computed: {
        progression() {
            return this.progress.index > 0 ? parseInt(100 * (this.progress.index / this.progress.items)) : null
        }
    },
    methods: {
        stringToFloat(string) {
            return Number(typeof string === 'string'? string.replace(/[^\d\.]/gi, '') : string)
        },
        preventDuplicates(role) {
            return 
        },
        stdRole(role) {
            return typeof str === 'string' ? str.trim().replace(/[^\s\D\d-]/g, '').toUpperCase().replace(/[\s]/g, '-') : null
        },
        saveRole() {
            this.$emit('saveRole')
            this.clearDialog()
        },
        clearDialog() {
            this.role = {
                id: null,
                name: null,
            }
            this.progress = {
                index: 0,
                items: null,
            }
            this.$emit('clearDialog')
        }
    },
    destroyed() {        
        this.clearDialog()
    },
}
</script>